/* ============================================================
   GW · Colección
   Lo único que hace falta en JS: que el desplegable de orden
   recargue al elegir. Sin JS, el formulario trae su propio
   botón dentro de un <noscript>, así que se sigue pudiendo usar.
   ============================================================ */

document.querySelectorAll('[data-gwcol-orden]').forEach((select) => {
  const formulario = select.closest('form');
  if (formulario) select.addEventListener('change', () => formulario.submit());
});